<template>
  <div class="desgin-share">
    <a-tabs v-model:activeKey="activeKey"
            tab-bar-gutter="0">
      <template #renderTabBar>
        <div class="tab-pane">
          <div :class="['tab', activeKey === '1' ? 'selected' : 'select']"
               @click="activeKey = '1'">
            {{ $t('CustomSpus.desginShare.portfolio') }}
          </div>
          <div v-if="usedOrderData.length || usedOrderImgData.length"
               :class="['tab', activeKey === '2' ? 'selected' : 'select']"
               @click="activeKey = '2'">
            {{ $t('CustomSpus.desginShare.purchased') }}
          </div>
        </div>
      </template>
      <a-tab-pane key="1"
                  :tab="$t('CustomSpus.desginShare.portfolio')">
        <div class="portfolio">
          <div class="desgin-share-fun">
            <a-input-search v-model:value="materialName"
                            :placeholder="$t('CustomSpus.desginShare.enterAuthorName')"
                            class="desgin-share-search"
                            @search="onSearchName" />
            <a-popover v-model:visible="visible"
                       trigger="click"
                       placement="bottomLeft">
              <template #content>
                <div class="tag-content">
                  <div v-for="tag in tagList"
                       :key="tag.id"
                       class="tag-content-box"
                       :class="selectTagName.includes(tag.name) ? 'selected-tag' : ''"
                       @click="selectTag(tag)">{{ tag.name }}
                    <div v-show="selectTagName.includes(tag.name)"
                         class="tag-icon"></div>
                  </div>
                </div>
                <div class="tag-footer">
                  <a-button class="cancel-btn"
                            @click="cancel">{{ $t('CustomSpus.desginShare.cancel') }}</a-button>
                  <a-button type="primary"
                            class="confirm-btn"
                            @click="confirm">{{ $t('CustomSpus.desginShare.confirm') }}</a-button>
                </div>
              </template>
              <div class="desgin-share-box">
                <MenuOutlined class="desgin-share-icon" />
              </div>
            </a-popover>
          </div>
          <div>
            <div v-for="(tag, index) in searchTag"
                 :key="index"
                 class="search-tag">
              {{ tag }}
            </div>
          </div>
          <div class="desgin-share-content">
            <div class="desgin-share-imgs-list">
              <div v-for="(item, index) in dssThemeListData"
                   :key="index"
                   class="desgin-share-tags-img">
                <span>{{ item.tag }}</span>
                <ul class="desgin-share-list">
                  <li v-for="dsstheme in item.dssThemeList"
                      :key="index"
                      class="desgin-share-item"
                      @click="onSelectedTheme(dsstheme, true)">
                    <a-popover trigger="hover"
                               :mouse-enter-delay='1'
                               placement="left"
                               :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
                      <template #content>
                        <div class="image-content">
                          <div
                               :class="['image-content-imgs', dsstheme.dssCustomizedImage.length != 1 ? 'image-content-js' : 'image-content-jc']">
                            <template v-for="(img, i) in dsstheme.dssCustomizedImage"
                                      :key="i">
                              <div v-if="i < 3"
                                   :class="['image-content-img', i === 3 ? 'image-content-img-mask' : '', dsstheme.dssCustomizedImage.length === 1 ? ' image-content-img-center' : '']">
                                <div v-if="i === 3"
                                     class="image-content-img-more">
                                  <span>{{ $t('CustomSpus.desginShare.more') }}</span>
                                  <span>{{ $t('CustomSpus.desginShare.design') }}</span>
                                </div>
                                <img v-if="dsstheme.dssCustomizedImage.length != 1"
                                     class="image-content-img"
                                     :src="toUrl(toWatermark(img.image)) + '?x-oss-process=image/resize,w_250/quality,q_90'" />
                                <img v-else
                                     class="image-content-one-img"
                                     :src="toUrl(toWatermark(img.image)) + '?x-oss-process=image/resize,w_250/quality,q_90'" />
                              </div>
                            </template>
                          </div>
                          <div class="image-content-text">
                            <div class="image-content-name">{{ dsstheme.title }}</div>
                            <div class="image-content-desginer">{{ $t('CustomSpus.desginShare.designer') }}: {{
                              hideMobileNumber(dsstheme.username) }}</div>
                            <div class="image-content-tagbox">
                              <div v-for="(tag, i) in dsstheme.tags?.split(',')"
                                   :key="i"
                                   class="image-content-tag">
                                <span>{{ tag }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <img class="desgin-share-img"
                           :src="dsstheme.dssCustomizedImage.length ? toUrl(toWatermark(dsstheme.dssCustomizedImage[0].image)) + '?x-oss-process=image/resize,w_200/quality,q_90' : ''" />
                    </a-popover>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2"
                  :tab="$t('CustomSpus.desginShare.purchased')"
                  force-render>
        <div class="usage-record">
          <div class="desgin-theme-list">
            <span class="title">{{ $t('CustomSpus.desginShare.designSet') }}：</span>
            <div class="desgin-share-content">
              <div class="desgin-share-bought">
                <ul class="desgin-share-list">
                  <li v-for="(item, index) in    usedOrderData   "
                      :key="index"
                      class="desgin-share-item"
                      @click="onSelectedTheme(item)">
                    <a-popover trigger="hover"
                               :mouse-enter-delay='1'
                               placement="left"
                               :get-popup-container="(triggerNode: any) => { return triggerNode.parentNode }">
                      <template #content>
                        <div class="image-content">
                          <div
                               :class="['image-content-imgs', item.dssCustomizedImage.length != 1 ? 'image-content-js' : 'image-content-jc']">
                            <template v-for="(img, i) in item.dssCustomizedImage   "
                                      :key="i">
                              <div v-if="i < 3"
                                   :class="['image-content-img', i === 3 ? 'image-content-img-mask' : '', item.dssCustomizedImage.length === 1 ? ' image-content-img-center' : '']">
                                <div v-if="i === 3"
                                     class="image-content-img-more">
                                  <span>{{ $t('CustomSpus.desginShare.more') }}</span>
                                  <span>{{ $t('CustomSpus.desginShare.design') }}</span>
                                </div>
                                <img v-if="item.dssCustomizedImage.length != 1"
                                     class="image-content-img"
                                     :src="toUrl(toWatermark(img.image)) + '?x-oss-process=image/resize,w_250/quality,q_90'" />
                                <img v-else
                                     class="image-content-one-img"
                                     :src="toUrl(toWatermark(img.image)) + '?x-oss-process=image/resize,w_250/quality,q_90'" />
                              </div>
                            </template>
                          </div>
                          <div class="image-content-text">
                            <div class="image-content-name">{{ item.title }}</div>
                            <div class="image-content-desginer">{{ $t('CustomSpus.desginShare.designer') }}: {{
                              hideMobileNumber(item.username) }}</div>
                            <div class="image-content-tagbox">
                              <div v-for="(   tag, i   ) in    item.tags?.split(',')   "
                                   :key="i"
                                   class="image-content-tag">
                                <span>{{ tag }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <img class="desgin-share-img"
                           :src="toUrl(toWatermark(item.dssCustomizedImage[0].image)) + '?x-oss-process=image/resize,w_200/quality,q_90'" />
                    </a-popover>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="desgin-theme-image-list">
            <span class="title">{{ $t('CustomSpus.desginShare.designItems') }}：</span>
            <div class="desgin-share-content">
              <div class="desgin-share-bought">
                <ul class="desgin-share-list">
                  <li v-for="(item, index) in usedOrderImgData"
                      :key="index"
                      class="desgin-share-item"
                      @click="handleOk(item)">
                    <img class="desgin-share-img"
                         :src="toUrl(toWatermark(item.image)) + '?x-oss-process=image/resize,w_100/quality,q_90'" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <a-modal v-model:visible="themeVisible"
             width="900px"
             :body-style="{ height: '500px', overflow: 'auto' }"
             :title="selectedTheme.dsstheme?.title"
             :destroy-on-close="true"
             @cancel="handleCancel">
      <div class="desgin-share-modal-desginer">{{ $t('CustomSpus.desginShare.designer') }}：{{
        hideMobileNumber(selectedTheme.dsstheme?.username as string) }}</div>
      <a-tag v-if="!selectedTheme.dsstheme?.shareable"
             color="orange">{{ $t('CustomSpus.desginShare.notShareable') }}</a-tag>
      <a-tag v-if="selectedTheme.dsstheme?.free"
             color="orange">{{ $t('CustomSpus.desginShare.limitedTimeFree') }}</a-tag>
      <div class="desgin-share-modal-desc">
        <span>{{ $t('CustomSpus.desginShare.usageInstructions') }}</span>
        <span>{{ $t('CustomSpus.desginShare.singleUse') }}</span>
        <span>{{ $t('CustomSpus.desginShare.permanentUse') }}</span>
      </div>
      <div class="desgin-share-modal-images">
        <div v-for="(   item, index   ) in    selectedTheme.dsstheme?.dssCustomizedImage   "
             :key="index"
             :class="['desgin-share-modal-content', findSelectedImage(item.id!) ? 'desgin-share-modal-border' : '']">
          <div class="desgin-share-modal-image"
               @click="addImage(item)"><img
                 :src="toUrl(toWatermark(item.image)) + '?x-oss-process=image/resize,w_200/quality,q_90'"
                 alt=""></div>
          <div class="desgin-share-modal-text"><span class="desgin-share-modal-price">¥ {{ item.ref_price }}</span></div>
        </div>
      </div>
      <template #footer>
        <div class="desgin-share-modal-footer">
          <div class="desgin-share-modal-buy">
            <a-radio v-model:checked="selectedTheme.buyWholeSet"
                     :disabled="selectedTheme.buyWholeSet || selectedTheme.dsstheme?.free"
                     @change="onBuyThemeImages">{{ $t('CustomSpus.desginShare.buyWholeSet') }}</a-radio>
            <div>{{ $t('CustomSpus.desginShare.designPackagePrice') }}:<span class="desgin-share-modal-price">¥ {{
              selectedTheme.dsstheme?.price }}</span></div>
          </div>
          <div class="desgin-share-modal-footer-buttons">
            <div class="desgin-share-modal-footer-button">
              <a-button key="back"
                        @click="handleCancel">{{ $t('CustomSpus.desginShare.cancel') }}</a-button>
              <a-popconfirm v-if="addToUserImg"
                            title="是否一并添加到画布?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="addToUserImgData(true)"
                            @cancel="addToUserImgData(false)">
                <a-button type="primary"
                          :loading="confirmLoading">{{ $t('CustomSpus.desginShare.addToPurchased') }}</a-button>
              </a-popconfirm>
              <a-button v-else
                        type="primary"
                        :loading="confirmLoading"
                        @click="handleOk">{{ $t('CustomSpus.desginShare.confirmUse') }}</a-button>
            </div>
          </div>
        </div>
      </template>
    </a-modal>
    <a-modal v-model:visible="payVisible"
             :title="$t('CustomSpus.desginShare.confirmPurchaseTitle', { title: selectedTheme.dsstheme?.title })"
             :destroy-on-close="true"
             @ok="confirmPay"
             @cancel="cancelPay">
      <div class="desgin-share-modal-desginer">{{ $t('CustomSpus.desginShare.designer') }}：{{
        hideMobileNumber(selectedTheme.dsstheme?.username as string) }}</div>
      <div class="desgin-share-modal-desc">
        <span>{{ $t('CustomSpus.desginShare.wholeSetUsageInstructions') }}</span>
        <span>{{ $t('CustomSpus.desginShare.permanentUsageInstructions') }}</span>
        <span>{{ $t('CustomSpus.desginShare.noRefund') }}</span>
      </div>
      <a-radio-group v-model:value="payType"
                     name="radioGroup">
        <a-radio :value="0">{{ $t('CustomSpus.desginShare.alipay') }}</a-radio>
        <a-radio :value="1">{{ $t('CustomSpus.desginShare.wechat') }}</a-radio>
        <a-radio :value="3">{{ $t('CustomSpus.desginShare.wallet') }}</a-radio>
      </a-radio-group>
    </a-modal>
    <a-modal v-model:visible="QRCodeVisible"
             :title="payType === 0 ? $t('CustomSpus.desginShare.alipayQRCode') : $t('CustomSpus.desginShare.wechatQRCode')"
             :z-index="1001"
             :mask-closable="false"
             :body-style="{ display: 'flex', justifyContent: 'center', flexFlow: 'column', alignItems: 'center' }"
             :ok-text="$t('CustomSpus.desginShare.paid')"
             @ok="onCancelOk"
             @cancel="QRCodeVisible = false">
      <div class="flex">
        <iframe v-if="payType === 0"
                :src="aliPayUrl"
                width="210"
                height="210"></iframe>
        <a-image v-else
                 :width="200"
                 :preview="false"
                 :src="code_img" />
      </div>
      <div class="flex">
        {{ $t('CustomSpus.desginShare.scanToPay') }}{{ payType === 0 ? $t('CustomSpus.desginShare.alipay') :
          $t('CustomSpus.desginShare.wechat') }}{{ $t('CustomSpus.desginShare.pay') }}
      </div>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { fetchShareThemeList, fetchMaterialTag, addDssOrder, dssWxpayQuery, fetchOrder, dssAlipayQuery, addUmsDssOrderItem } from '../../api/index'
import { toUrl, toWatermark, hideMobileNumber } from '@/utils'
import type { DssTheme, BuyDssTheme, DssCustomizedImage, DssThemeTag, MaterialTag, SelectTags, UserDssCustomizedImage } from '../../types'
import { message } from 'ant-design-vue'
import QRCode from 'qrcode'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const visible = ref<boolean>(false)
const themeVisible = ref<boolean>(false)
const payVisible = ref<boolean>(false)
const dssThemeListData = ref<DssThemeTag[]>([])
const tagList = ref<MaterialTag[]>([])
const materialName = ref<string>('')
const payType = ref<number | null>(null)
const addToUserImg = ref<boolean>(false)
const number = ref<string>('')
const QRCodeVisible = ref<boolean>(false)
const aliPayUrl = ref<string>('')
const code_img = ref('')
const activeKey = ref<string>('1')
const usedOrderImgData = ref<UserDssCustomizedImage[]>([])
const usedOrderData = ref<DssTheme[]>([])
const selectedTheme = ref<BuyDssTheme>({
  dsstheme: undefined,
  selectedCustomizedImages: [],
  buyWholeSet: false
})
const emit = defineEmits(['update:modelValue', 'onSelectdDss', 'toLogin', 'isBuyWholeSet'])
const tenant = JSON.parse(localStorage.getItem("user") || '{}').user || null
const confirmLoading = ref<boolean>(false)
const props = defineProps<{
  isEditable: boolean
  isCustomized: boolean
  isLogin: boolean
}>()
onMounted(async () => {
  await fetchMaterialTag().then(result => {
    tagList.value = result.data.items
  })
  await onFetchOrder()
  await onFetchShareThemeList()
})

const onFetchOrder = async () => {
  await fetchOrder().then((result: any) => {
    usedOrderData.value = []
    usedOrderImgData.value = []
    result.dssOrder.forEach((r: any) => {
      if (r.type === 1) {
        if (r.theme.status != 4)
          return
        r.theme.shareImages.forEach((res: DssCustomizedImage) => {
          usedOrderImgData.value.push({
            ...res,
            theme: r.theme
          })
        })
      }
      if (r.status === 1 || r.status === 2) {
        usedOrderData.value.push({
          id: r.theme.id,
          status: r.theme.status,
          price: r.theme.price,
          title: r.theme.title,
          tags: r.theme.tags,
          tenant: r.theme.tenant,
          desc: r.theme.desc,
          shareable: r.theme.shareable,
          free: r.theme.free,
          customable: r.theme.customable,
          discountable: r.theme.discountable,
          discountRate: r.theme.discountRate,
          editable: r.theme.editable,
          username: r.theme.user.username,
          orderStatus: r.status,
          type: r.type,
          dssCustomizedImage: r.theme.shareImages
        })
      }
    })
  })
}

const onFetchShareThemeList = async (data?: SelectTags) => {
  await fetchShareThemeList(data).then((result: any) => {
    dssThemeListData.value = []
    tagList.value.forEach((r: MaterialTag) => {
      const tagCategory: DssThemeTag = {
        tag: r.name,
        dssThemeList: [],
        showNumber: 20
      }
      result.forEach((res: DssTheme) => {
        if (res.tags.includes(r.name)) {
          const confirmRepeat = dssThemeListData.value.some((l: DssThemeTag) => {
            if (l.dssThemeList.find((j: DssTheme) => j.id === res.id))
              return true
            return false
          })
          if (!confirmRepeat && res.tenant != tenant?.id && res.id != result.id && !res.orderDetails?.length) {
            tagCategory.dssThemeList.push(res)
          }
        }
      })
      if (tagCategory.dssThemeList.length) {
        dssThemeListData.value.push(tagCategory)
      }
    })
  })
}

const onFetchShareThemeTag = async (data?: SelectTags) => {
  await fetchShareThemeList(data).then((result: any) => {
    dssThemeListData.value = []
    searchTag.value.forEach((r: string) => {
      const tagCategory: DssThemeTag = {
        tag: r,
        dssThemeList: [],
        showNumber: 20
      }
      result.forEach((res: DssTheme) => {
        if (res.tags.includes(r)) {
          const confirmRepeat = dssThemeListData.value.some((l: DssThemeTag) => {
            if (l.dssThemeList.find((j: DssTheme) => j.id === res.id))
              return true
            return false
          })
          if (!confirmRepeat && res.tenant != tenant.id && (res.orderDetails && !res.orderDetails.length)) {
            tagCategory.dssThemeList.push(res)
          }
        }
      })
      if (tagCategory.dssThemeList.length) {
        dssThemeListData.value.push(tagCategory)
      }
    })
  })
}

const onCancelOk = async () => {
  if (payType.value === 0) {
    const data = { number: `${number.value}` }
    const res: any = await dssAlipayQuery(data)
    if (res.msg == 'success') {
      message.success(t('CustomSpus.desginShare.paymentSuccess'))
      payVisible.value = false
      QRCodeVisible.value = false
      payType.value = null
      selectedTheme.value.buyWholeSet = true
      emit('isBuyWholeSet', Object.assign({}, selectedTheme.value))
      await onFetchOrder()
      await onFetchShareThemeList()
    } else {
      message.error(t('CustomSpus.desginShare.paymentOrderNotFound'))
    }
  } else if (payType.value === 1) {
    const data = { number: `${number.value}-PC` }
    const res: any = await dssWxpayQuery(data)
    if (res.result.result_code == 'SUCCESS' && res.result.trade_state == 'SUCCESS') {
      message.success(res.result.trade_state_desc)
      payVisible.value = false
      QRCodeVisible.value = false
      payType.value = null
      selectedTheme.value.buyWholeSet = true
      emit('isBuyWholeSet', Object.assign({}, selectedTheme.value))
      await onFetchOrder()
      await onFetchShareThemeList()
    } else {
      message.error(res.result.trade_state_desc)
    }
  }
}

const confirmPay = async () => {
  if (!payType.value && payType.value != 0) {
    selectedTheme.value.buyWholeSet = false
    payVisible.value = false
    return
  }
  if (selectedTheme.value.dsstheme) {
    const addDssOrderData = {
      themeId: selectedTheme.value.dsstheme.id,
      payType: payType.value,
      price: selectedTheme.value.dsstheme.price,
      title: selectedTheme.value.dsstheme.title
    }
    await addDssOrder(addDssOrderData).then(async (res: any) => {
      if (payType.value === 1) {
        number.value = res.number
        QRCodeVisible.value = true
        code_img.value = await QRCode.toDataURL(res.url)
      } else if (payType.value === 0) {
        aliPayUrl.value = res.url
        number.value = res.number
        QRCodeVisible.value = true
      } else {
        if (res.message == 'SUCCESS') {
          message.success(t('CustomSpus.desginShare.paymentSuccess'))
        }
        payVisible.value = false
        payType.value = null
      }
    }).catch((err: any) => {
      if (err.message == 'Insufficient balance')
        message.error(t('CustomSpus.desginShare.insufficientBalance'))
      else
        message.error(err.message)
    })
  }
}
const addToUserImgData = async (value: boolean) => {
  const data = {
    dss_theme_id: selectedTheme.value.dsstheme?.id,
    dss_customized_image_id: selectedTheme.value.selectedCustomizedImages.map((r: DssCustomizedImage) => r.id)
  }
  await addUmsDssOrderItem(data).then((res: any) => {
    message.success(t('CustomSpus.desginShare.hintAddToPurchased'))
  })
  if (value) {
    handleOk()
  } else {
    cancel()
  }
}

const cancelPay = () => {
  selectedTheme.value.buyWholeSet = false
  payVisible.value = false
}
const handleOk = (value?: UserDssCustomizedImage) => {
  if (value) {
    if (!props.isEditable || (!value.theme.shareable && props.isCustomized)) {
      message.error(t('CustomSpus.desginShare.hintError'))
    } else {
      emit('onSelectdDss', Object.assign({}, {
        dsstheme: value.theme,
        selectedCustomizedImages: [value],
        buyWholeSet: false
      }))
    }
  } else {
    if (!selectedTheme.value.selectedCustomizedImages.length) {
      themeVisible.value = false
      selectedTheme.value.dsstheme = undefined
      selectedTheme.value.selectedCustomizedImages = []
      selectedTheme.value.buyWholeSet = false
      return
    }
    if (!props.isEditable || (!selectedTheme.value.dsstheme?.shareable && props.isCustomized)) {
      message.error(t('CustomSpus.desginShare.hintError'))
    } else {
      emit('onSelectdDss', Object.assign({}, selectedTheme.value))
      themeVisible.value = false
      selectedTheme.value.dsstheme = undefined
      selectedTheme.value.selectedCustomizedImages = []
      selectedTheme.value.buyWholeSet = false
    }
  }
}
const onBuyThemeImages = () => {
  if (!props.isLogin) {
    emit('toLogin')
  } else {
    payVisible.value = true
  }
  // selectedTheme.value.buyWholeSet
}
const findSelectedImage = (id: number) => {
  return selectedTheme.value.selectedCustomizedImages.find((r: DssCustomizedImage) => r.id === id)
}
const handleCancel = () => {
  themeVisible.value = false
  selectedTheme.value.dsstheme = undefined
  selectedTheme.value.selectedCustomizedImages = []
  selectedTheme.value.buyWholeSet = false
}
const onSearchName = () => {
  const data: SelectTags = {
    name: materialName.value
  }
  onFetchShareThemeList(data)
}
const selectTagName = ref<string[]>([])
const selectTag = (item: any) => {
  if (selectTagName.value.includes(item.name)) {
    selectTagName.value = selectTagName.value.filter(el => el != item.name)
  } else {
    selectTagName.value.push(item.name)
  }
}
const onSelectedTheme = (theme: DssTheme, toUserData?: boolean) => {
  addToUserImg.value = false
  selectedTheme.value.dsstheme = theme
  selectedTheme.value.buyWholeSet = (theme.orderStatus === 1 || theme.orderStatus === 2)
  themeVisible.value = true
  if (toUserData) {
    addToUserImg.value = true
  }
}
const addImage = (customizedImage: DssCustomizedImage) => {
  const savingImage = selectedTheme.value.selectedCustomizedImages.findIndex((r: DssCustomizedImage) => r.id === customizedImage.id)
  if (savingImage === -1) {
    if (!props.isEditable || (!selectedTheme.value.dsstheme?.shareable && (selectedTheme.value.selectedCustomizedImages.length || props.isCustomized))) {
      message.error(t('CustomSpus.desginShare.noRedesign'))
    } else {
      selectedTheme.value.selectedCustomizedImages.push(customizedImage)
    }
  } else {
    selectedTheme.value.selectedCustomizedImages.splice(savingImage, 1)
  }
}
const searchTag = ref<string[]>([])
const confirm = async () => {
  const data: SelectTags = {
    tag: selectTagName.value.join(',')
  }
  if (materialName.value) {
    data.name = materialName.value
  }
  searchTag.value = []
  tagList.value.forEach((tag) => {
    if (selectTagName.value?.includes(tag.name)) {
      searchTag.value.push(tag.name)
    }
  })
  await onFetchShareThemeTag(data).then(() => {
    visible.value = false
  })
}
const cancel = async () => {
  selectTagName.value = []
  const data: SelectTags = {
    name: materialName.value
  }
  await onFetchShareThemeList(data).then(() => {
    searchTag.value = []
    visible.value = false
  })
}
</script>
<style scoped lang="less">
.desgin-share {
  width: 300px;
  flex: 1;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-flow: column;
  overflow: hidden;

  :deep(.ant-popover-inner-content) {
    padding: 0 !important;
  }

  .tab-pane {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 10px;

    .tab {
      flex: 1;
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .select {
      font-size: 18px;
      font-family: 'Microsoft YaHei';
      font-weight: 600;
      color: #999999;
    }

    .selected {
      font-size: 18px;
      font-family: 'Microsoft YaHei';
      font-weight: 600;
      color: #111111;
    }
  }

  .search-tag {
    display: inline-block;
    width: fit-content;
    min-width: 68px;
    height: 24px;
    line-height: 24px;
    background: #F6F6F6;
    padding: 0 5px;
    font-size: 14px;
    color: #999;
    text-align: center;
    margin: 0 6px 10px 0;
  }

  .desgin-share-fun {
    display: flex;
    justify-content: space-around;

    .desgin-share-search {
      flex: 1;
      margin-bottom: 10px;

      :deep(.ant-input) {
        height: 32px;
      }

      :deep(.ant-btn) {
        height: 30px;
        box-sizing: content-box;
        border: 1px solid #ccc;
        background: #f6f6f6;
      }
    }

    .desgin-share-box {
      flex: 1;
      max-width: 32px;
      max-height: 32px;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      border: 1px solid #ccc;
      background: #f6f6f6;
      margin-left: 12px;
      cursor: pointer;

      .desgin-share-icon {
        font-size: 18px;
        color: #999;
      }
    }
  }


  .usage-record {
    flex: 1;
    display: flex;
    flex-flow: column;

    .title {
      font-weight: 400;
      font-size: 16px;
    }

    .desgin-theme-list {
      flex: 1;
      overflow: auto;
    }

    .desgin-theme-image-list {
      flex: 1;
      overflow: auto;
    }
  }

  .desgin-share-content {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    scrollbar-width: thin;
    /* Firefox */
    scrollbar-color: transparent transparent;
    /* Firefox */

    .desgin-share-bought {
      padding-top: 10px;
      box-shadow: 3px 0 10px #e8e3e3;
      height: 60%;
      background-color: white;

      .desgin-share-bought-title {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .open-bought-list {
      height: 8%;
    }

    .desgin-share-imgs-list {
      flex: 1;
      width: 100%;
      overflow: auto;
    }

    .desgin-share-tags-img {
      flex: 1;
      width: 100%;

      span {
        font-weight: 400;
        font-size: 16px;
      }
    }

    .desgin-share-list {
      z-index: 999;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      overflow: auto;

      .desgin-share-item {
        background-color: #F6F6F6;
        width: 80px;
        height: 80px;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .desgin-share-img {
          max-width: 80px;
          width: auto;
          max-height: 80px;
          height: auto;
        }
      }

      .desgin-share-item:nth-child(3n) {
        margin-right: 0px !important;
      }
    }
  }

  .desgin-share-content::-webkit-scrollbar {
    width: 0;
  }
}

.tag-content {
  width: 510px;
  padding: 8px 4px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;

  .tag-content-box {
    position: relative;
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #F1F1F1;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;

    .tag-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 18px;
      height: 18px;
      background: url('../../icon/ic_subscript.png');
    }
  }

  .selected-tag {
    border: 1px solid #111111;
  }
}

.tag-footer {
  padding: 8px 4px;
  text-align: right;

  .cancel-btn {
    background-color: #f6f6f6;
    width: 98px;
    height: 40px;
    margin-right: 10px;
  }

  .confirm-btn {
    width: 98px;
    height: 40px;
  }
}

.image-content {
  width: 255px;
  height: 100%;
  padding-bottom: 10px;

  .image-content-js {
    justify-content: space-between;
  }

  .image-content-jc {
    justify-content: center;
  }

  .image-content-imgs {
    padding: 10px;
    height: 255px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .image-content-img-center {
      justify-content: center !important;
    }

    .image-content-img-mask {
      width: 110px;
      height: 110px;
      position: relative;

      .image-content-img-more {
        width: 110px;
        height: 110px;
        position: absolute;
        background-color: #111111;
        opacity: 0.6;
        top: 0;
        left: 0;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        color: white;
      }
    }

    .image-content-img {
      margin-bottom: 5px;
      max-width: 110px;
      max-height: 110px;
      display: flex;
      justify-content: center;
      background: #f6f6f6;
    }

    .image-content-one-img {
      display: flex;
      justify-content: center;
      width: 255px;
      height: 255px;
      // min-height: 255px;
      // min-width: 255px;
      // height: auto;
      // width: auto;
      background: #f6f6f6;
    }

    // img {
    //   max-width: 110px;
    //   width: auto;
    //   max-height: 110px;
    //   height: auto;
    // }
  }

  .image-content-text {
    flex: 1;
    margin: 10px;

    .image-content-name {
      word-wrap: break-word;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #111111;
    }

    .image-content-desginer {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }

    .image-content-tagbox {
      display: flex;
      flex-wrap: wrap;

      .image-content-tag {
        min-width: 68px;
        height: 24px;
        line-height: 24px;
        background: #F6F6F6;
        padding: 0 5px;
        font-size: 14px;
        color: #999;
        text-align: center;
        margin: 0 6px 6px 0;
      }
    }
  }
}
</style>

<style lang="less">
.desgin-share-modal-desginer {
  width: 100%;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111111;
  margin-bottom: 5px;

  span {
    margin-right: 10px;
  }
}

.desgin-share-modal-price {
  padding-left: 10px;
  font-weight: bold;
  font-size: 16px;
  color: #DE4A09;
}

.desgin-share-modal-desc {
  margin-top: 5px;
  margin-bottom: 20px;
  padding: 5px;
  background: #F6F6F6;
  display: flex;
  flex-flow: column;

  span {
    font-size: 12px;
    color: #999999;
  }
}

.desgin-share-modal-images {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;

  .desgin-share-modal-content {
    width: 180px;
    height: 210px;
    border: 1px solid #F1F1F1;
    display: flex;
    flex-flow: column;

    .desgin-share-modal-text {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .desgin-share-modal-image {
      height: 180px;
      width: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #F6F6F6;

      img {
        vertical-align: middle;
        max-width: 180px;
        width: auto;
        max-height: 180px;
        height: auto;
      }
    }
  }

  .desgin-share-modal-border {
    outline: 1px solid black;
  }
}

.desgin-share-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .desgin-share-modal-buy {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .desgin-share-modal-footer-buttons {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .desgin-share-modal-footer-button {
      flex: 1;
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
